import styled from '@emotion/styled';
import { Box } from '@chakra-ui/react';

export const TableBox = styled(Box)`
  margin: 12px 0;
  padding: 12px;
  border: 1px solid #777;
  border-radius: 8px;
`;
